module.exports = __webpack_public_path__ + "img/operations.a3c982c3.jpg";